export default __webpack_public_path__ + "static/media/080_finish_bad.last.3565c201.avif";